import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import DailyDashboard from "@/pages/DailyDashboard";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import JobByNumber from "@/pages/JobByNumber";
import ScanView from "@/pages/ScanView";
import Production from "@/pages/Production";
import AvtAnalytics from "@/pages/AvtAnalytics";
import Inventory from "@/pages/Inventory";
import Machines from "@/pages/Machines";
import Equipment from "@/pages/Equipment";
import Operators from "@/pages/Operators";
import Users from "@/pages/Users";
import CsvImport from "@/pages/CsvImport";
import Sales from "@/pages/Sales";
import Purchases from "@/pages/Purchases";
import Customers from "@/pages/Customers";
import Reports from "@/pages/Reports";
import RoleViews from "@/pages/RoleViews";
import OpsDashboard from "@/pages/OpsDashboard";
import SalesDashboard from "@/pages/SalesDashboard";
import Advisor from "@/pages/Advisor";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/s/:number" element={<ProtectedRoute><ScanView /></ProtectedRoute>} />
              <Route
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<Dashboard />} />
                <Route path="/daily" element={<DailyDashboard />} />
                {/* the Alert Board lived here: old links and open tabs land on the Daily Dashboard */}
                <Route path="/alerts" element={<Navigate to="/daily" replace />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/orders/no/:number" element={<JobByNumber />} />
                <Route path="/orders/:id" element={<OrderDetail />} />
                <Route path="/production" element={<Production />} />
                <Route path="/avt" element={<AvtAnalytics />} />
                <Route path="/inventory" element={<Inventory />} />
                <Route path="/machines" element={<Machines />} />
                <Route path="/equipment" element={<Equipment />} />
                <Route path="/operators" element={<Operators />} />
                <Route path="/sales" element={<Sales />} />
                <Route path="/purchases" element={<Purchases />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/users" element={<Users />} />
                <Route path="/import" element={<CsvImport />} />
                <Route path="/views" element={<RoleViews />} />
                <Route path="/ops" element={<OpsDashboard />} />
                <Route path="/sales-dashboard" element={<SalesDashboard />} />
                <Route path="/advisor" element={<Advisor />} />
              </Route>
            </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
